class WindowLocation {
    static getWindowLocation = () => {
        const {location: $location} = window;
        let $hashTags = $location;
        $hashTags.hashObj = false;
        $hashTags.hrefOrigin = $location.href;

        if ($location.hash) {
            $hashTags.hrefOrigin = $location.href.replace($location.hash, '');

            let hashs = $location.hash.split('/');
            let hashObj = hashs.filter((hash) => hash !== '#');
            $hashTags.hashObj = {};

            for (let i = 0; i <= hashObj.length; i++) {
                if (!hashObj.hasOwnProperty(i)) {
                    continue;
                }
                let key = hashObj[i];
                i++;

                if (key && hashObj.hasOwnProperty(i) && hashObj[i]) {
                    let v = hashObj[i];
                    if(key === 'page') {
                        v = parseInt(v);
                    }

                    if(key === 's') {
                        v = decodeURIComponent(v);
                    }

                    $hashTags.hashObj[key] = v;
                } else {
                    $hashTags.hashObj[key] = null;
                }
            }
        }

        $hashTags.getHashObj = (key) => {
            return (window.location.hashObj && window.location.hashObj[key]) ? window.location.hashObj[key] : false;
        }

        $hashTags.addHash = (key, value) => {
            if(key === 'page') {
                value = parseInt(value);
            }

            if (!window.location.hashObj) {
                window.location.hashObj = {[key]: value};
            } else {
                window.location.hashObj[key] = value;
            }
        }

        $hashTags.removeHash = (key) => {
            if (window.location.hashObj && window.location.hashObj[key]) {
                delete window.location.hashObj[key];
            }
        }

        $hashTags.getHashToString = (hashObj = {}) => {
            console.log(window.location.hashObj);
            hashObj = {...window.location.hashObj, ...hashObj};
            let hash = null;

            if (hashObj) {
                hash = '';

                Object.entries(hashObj).map(([f, v]) => {
                    if (f !== 'page') {
                        hash += `/${f}/${v}`;
                    }
                });

                hash = (hashObj.page) ? `${hash}/page/${hashObj.page}` : hash;
            }

            return hash ? `#${hash}` : '';
        }

        $hashTags.getActiveUrl = (url) => {
            if(url[url.length-1] === '/' && window.location.hrefOrigin[window.location.hrefOrigin.length-1] !== '/') {
                window.location.hrefOrigin += '/';
            }
            if(url[url.length-1] !== '/' && window.location.hrefOrigin[window.location.hrefOrigin.length-1] === '/') {
                url += '/';
            }

            return (url === window.location.hrefOrigin);
        }

        return $hashTags;
    }

    static rewriteUrl = (data = {}, title = null, url = window.location.hrefOrigin, applyHash = true) => {
        if (applyHash) {
            url = `${url}${window.location.hrefOrigin[window.location.hrefOrigin.length - 1] === '/' ? '' : '/'}${window.location.getHashToString()}`;
        }

        window.history.pushState(data, title, url);
        this.getWindowLocation();
    }
}

export default WindowLocation;